<template>
  <b-card>
    <b-card-title class="text-center">
      <h1>Complete Vendor Registration</h1>
    </b-card-title>
    <b-card-body>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.companyName">
            <label for="company-name"
              ><span class="text-muted">Company Name:</span>
              {{ vendorDetails.companyName.title }}</label
            >
          </b-form-group>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.vendorType">
            <label for="vendor-type"
              ><span class="text-muted">Vendor Type:</span>
              {{ vendorDetails.vendorType.title }}</label
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.cinNumber">
            <label for="cin-number"
              ><span class="text-muted">CIN Number: </span>
              {{ vendorDetails.cinNumber }}</label
            >
          </b-form-group>
          <b-form-group v-if="vendorDetails.shopActNumber">
            <label for="shop-act-number"
              ><span class="text-muted">Shop Act Number: </span
              >{{ vendorDetails.shopActNumber }}</label
            >
          </b-form-group>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.owners">
            <label for="vendor-type">
              <span class="text-muted">Company Address: </span>
              {{ vendorDetails.owners.companyAddress }}</label
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.panNumber">
            <label for="pan-number"
              ><span class="text-muted">PAN Number: </span
              >{{ vendorDetails.panNumber }}
            </label>
          </b-form-group>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.gstNumber">
            <label for="gst-number"
              ><span class="text-muted">GST Number: </span
              >{{ vendorDetails.gstNumber }}</label
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.panCard">
            <label for="pan-card" class="text-muted"
              >PAN Card Image: &nbsp;</label
            >
            <b-button variant="primary"
              ><i class="feather icon-file-text"></i> Download PAN
              Card</b-button
            >
          </b-form-group>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.gstCertificate">
            <label for="gst-certificate" class="text-muted"
              >GST Certificate: &nbsp;</label
            >
            <b-button variant="primary"
              ><i class="feather icon-file-text"></i> Download GST
              Certificate</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.bankAccounts.length > 0">
            <label>Bank Accounts:</label><br />
            <div v-for="bank in vendorDetails.bankAccounts">
              <label
                ><span class="text-muted">IFSC Code:</span>
                {{ bank.bankIFSC }} &nbsp; &nbsp;</label
              >
              <label
                ><span class="text-muted">Account Number:</span>
                {{ bank.bankAccountNumber }}</label
              >
              <label
                ><span class="text-muted">Bank Name:</span> State Bank of
                India</label
              >
              <hr />
            </div>
          </b-form-group>
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <b-form-group v-if="vendorDetails.mobileNumber">
            <label
              ><span class="text-muted">Contact Person:</span>&nbsp;{{
                vendorDetails.contactPerson
              }}</label
            ><br />
            <label
              ><span class="text-muted">Mobile Number:</span>&nbsp;{{
                vendorDetails.mobileNumber
              }}</label
            >
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormText,
  BFormFile,
  BImg,
  BButton,
} from "bootstrap-vue";

export default {
  props: ["vDetails"],
  components: {
    BCard,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormText,
    BFormFile,
    BImg,
    BButton,
  },
  data() {
    return {
      vendorDetails: this.vDetails,
    };
  },
  mounted() {
    // console.log(this.vendorDetails);
  },
  methods: {},
};
</script>

<style>
</style>